import { InputWithLabel } from '@adotel/components'
import {
  Button,
  Modal,
  Paper,
  Slide,
  useMediaQuery,
  useTheme
} from '@material-ui/core'
import Typography from '@material-ui/core/Typography/Typography'
import EditIcon from '@material-ui/icons/Edit'
import SearchIcon from '@material-ui/icons/Search'
import { matchSorter } from 'match-sorter'
import { useEffect, useState } from 'react'

import { getDirection, getTranslate } from '../../localization'
import {
  RatePlanForChannelMappingWithRatePlanInput,
  RatePlanForChannelapping
} from '../../types/channelMapping'
import RatePlansCodeMapingModalRow from './RatePlansCodeMapingModalRow'
import useStyles from './styles/RatePlansCodeMappingModal.styles'

interface RatePlansCodeMappingModalProps {
  isOpen: boolean
  onClose: () => void
  data: RatePlanForChannelapping[]
  setData: (data: RatePlanForChannelapping[]) => void
  onRatePlansChange: (
    AdotelCode: string,
    rateplans: RatePlanForChannelapping[],
    updatedRateplans: RatePlanForChannelMappingWithRatePlanInput[]
  ) => void
  adotelCodeForRoomtype: string
  changedData: RatePlanForChannelMappingWithRatePlanInput[]
  setChangedData: React.Dispatch<
    React.SetStateAction<RatePlanForChannelMappingWithRatePlanInput[]>
  >
  customizedForChannel?: boolean
}
const RatePlansCodeMappingModal: React.FC<RatePlansCodeMappingModalProps> = ({
  isOpen,
  onClose,
  data,
  setData,
  onRatePlansChange,
  adotelCodeForRoomtype,
  changedData,
  setChangedData
}) => {
  const classes = useStyles()
  const theme = useTheme()
  const [searchInput, setsearchInput] = useState<string>('')

  const filterRatePlans = (inputValue: string) => {
    const ans = matchSorter(data, inputValue, {
      keys: ['AdotelName', 'AdotelCode']
    })
    return ans
  }

  useEffect(() => {
    if (onRatePlansChange && changedData.length > 0) {
      onRatePlansChange(adotelCodeForRoomtype, [], changedData)
    }
  }, [changedData])

  const disabled = data.some(
    (item) =>
      item.ChannelCode?.toLocaleLowerCase() === 'nodata' ||
      item.ChannelCode === ''
  )

  return (
    <Modal
      open={isOpen}
      className={classes.modal}
      dir={getDirection()}
      onClose={onClose}>
      <Slide direction="down" in={isOpen}>
        <Paper className={classes.ratePlansPaper}>
          <EditIcon className={classes.editIcon} color="primary" />
          <div className={classes.title}>
            <Typography variant="h3">{getTranslate('RatePlans')}</Typography>
          </div>
          <div className={classes.inputWithLabel}>
            <InputWithLabel
              startIcon={<SearchIcon />}
              noHelperText
              placeholder={getTranslate('Search in RatePlans names & codes')}
              onChange={(event) => setsearchInput(event.currentTarget.value)}
            />
          </div>
          <div className={classes.tableHead}>
            <div>
              <Typography variant="body1">{getTranslate('Name')}</Typography>
            </div>
            <div>
              <Typography variant="body1">
                {getTranslate('Provider')}
              </Typography>
            </div>
            {useMediaQuery(theme.breakpoints.up('sm')) && (
              <div>
                <Typography variant="body1">
                  {getTranslate('Adotel Code')}
                </Typography>
              </div>
            )}
            <div>
              <Typography variant="body1">
                {getTranslate('Channel Code')}
              </Typography>
            </div>
          </div>
          {filterRatePlans(searchInput).map((item, ratePlanIndex) => {
            return (
              <RatePlansCodeMapingModalRow
                key={ratePlanIndex}
                AdotelCode={item.AdotelCode}
                AdotelName={item.AdotelName}
                ChannelCode={item.ChannelCode}
                ProviderName={item.ProviderName}
                onChange={(channelCode) => {
                  const index = data.indexOf(item)
                  setData([
                    ...data.slice(0, index),
                    {
                      AdotelCode: item.AdotelCode,
                      AdotelName: item.AdotelName,
                      ChannelCode: channelCode,
                      ProviderName: item.ProviderName
                    },
                    ...data.slice(index + 1)
                  ])
                  const singleChangeObj: RatePlanForChannelMappingWithRatePlanInput =
                    {
                      AdotelCode: data[index].AdotelCode,
                      ChannelCode: channelCode
                    }
                  const existIndex = changedData.findIndex(
                    (ele) => ele.AdotelCode === data[index].AdotelCode
                  )
                  if (existIndex === -1) {
                    setChangedData([...changedData, singleChangeObj])
                  } else {
                    setChangedData((prevState) => {
                      const newState = [...prevState]
                      newState[existIndex] = singleChangeObj
                      return newState
                    })
                  }
                }}
              />
            )
          })}
          <div className={classes.buttonsStyles}>
            <Button variant="text" color="primary" onClick={onClose}>
              {getTranslate('Cancel')}
            </Button>
            <Button
              variant="contained"
              color="primary"
              disabled={disabled}
              className={classes.saveButton}
              onClick={() => {
                onClose()
              }}>
              {getTranslate('Save')}
            </Button>
          </div>
        </Paper>
      </Slide>
    </Modal>
  )
}
export default RatePlansCodeMappingModal
